import {
  css,
  inputAdornmentClasses,
  inputBaseClasses,
  outlinedInputClasses,
  Theme,
  typographyClasses,
} from '@mui/material'
import { uiColors } from '~/common/styles/colors'
import { typography } from '~/common/styles/typography'
import { InputProps } from '~/components/ui/atoms/input/types'

export const inputBasePrimitives = {
  borderRadius: '2px',
  color: uiColors.content.primary,
  backgroundColor: uiColors.background.white,
  ...typography.input,
  ...css`
   & input[type=number] {
    '-moz-appearance': 'textfield';
  }
  & input[type=number]::-webkit-outer-spin-button {
    '-webkit-appearance': 'none';
    margin: 0;
  }
  & input[type=number]::-webkit-inner-spin-button {
    '-webkit-appearance': 'none';
    margin: 0;
  }`,
  [`& .${outlinedInputClasses.input}`]: {
    padding: 0,
    fontSize: '16px',
    '@media (min-width: 768px)': {
      fontSize: '14px',
    },
  },
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.normal}`,
    '&:hover': {
      border: `1px solid ${uiColors.border.hover}`,
    },
  },
  [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.hover}`,
  },
  [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.focus}`,
  },
  [`&.${outlinedInputClasses.disabled}`]: {
    backgroundColor: uiColors.background.disabled,
    color: uiColors.content.disabled,
    [`& .${outlinedInputClasses.notchedOutline}`]: {
      border: `1px solid ${uiColors.background.disabled}`,
    },
  },
  [`& .${inputAdornmentClasses.root}`]: {
    [`& .${typographyClasses.root}`]: {
      ...typography.body1,
    },
  },
}

export const inputErrorPrimitives = {
  color: uiColors.content.primary,
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.danger}`,
  },
  [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.danger}`,
  },
  [`&:focus-within .${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.danger}`,
  },
  [`&.${outlinedInputClasses.focused}.${outlinedInputClasses.notchedOutline}`]: {
    border: `1px solid ${uiColors.border.danger}`,
  },
  [`&.MuiOutlinedInput-root.Mui-focused fieldset`]: {
    border: `1px solid ${uiColors.border.danger}`,
  },
}

export function getLongTextFieldPrimitives(longTextField: boolean | undefined, theme: Theme) {
  if (longTextField) {
    return {
      padding: theme.spacing(0.25),
      [`& .${inputBaseClasses.inputMultiline}`]: {
        padding: theme.spacing(1),
        resize: 'auto',
        overflow: 'auto',
        minHeight: '18px',
      },
    }
  }
  return {}
}

export function getInputColorPrimitives({
  variant = 'primary',
}: Pick<InputProps, 'variant' | 'disabled' | 'error'>) {
  switch (variant) {
    case 'standard':
    case 'rounded':
    case 'primary': {
      return {}
    }
    case 'warning': {
      return {
        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
          border: `1px solid ${uiColors.border.warning}`,
        },
        [`& .${outlinedInputClasses.inputAdornedEnd}`]: {
          color: uiColors.content.warning,
        },
      }
    }
  }
}
